import { LottieControl } from 'Organisms/LottieControl';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FDBox } from '@facet-wealth/design';
import { useLottieLoadingContext } from 'Organisms/LottieControl/LottieLoadingLayout';

export const FacLoadingLottie = ({ rel }) => {
  const { setIsContentShowing } = useLottieLoadingContext();

  useEffect(() => {
    if (rel) {
      setIsContentShowing(false);
    }
  }, [rel]);

  return (
    <FDBox paddingY={3}>
      <LottieControl
        src={rel.link('related').url()}
        width="350px"
        height="auto"
        onLoadSuccess={() => setIsContentShowing(true)}
        onLoadError={() => setIsContentShowing(true)}
      />
    </FDBox>
  );
};

FacLoadingLottie.propTypes = {
  rel: PropTypes.object.isRequired,
};
